import { createSelector } from 'reselect';

const adminRootSelector = (state: TReduxState) => state.root.admin;
const adminAppSelector = createSelector(adminRootSelector, (state) => state.app)

export const selectAdminSidebar = createSelector(adminAppSelector, (state) => state.sidebar)
export const selectDrawerUser = createSelector(adminAppSelector, (state) => state.drawerUser)
export const selectDrawerPendingTransaction = createSelector(adminAppSelector, (state) => state.drawerPendingTransaction)
export const selectRequestDrawer = createSelector(adminAppSelector, (state) => state.requestDrawer)